module.exports = __webpack_public_path__ + "img/F979.1bbe25e8.jpg";